import { Filter, FilterGroup } from "../../../core/_shared/models/filter.model";
import { DbObjectBase } from './db-object-base';
import { ICollectionReference } from '../database-cast/IDatabase';
import { FilterParam } from '../../_shared/intelli-controls/intelli-data-list';

export class DbLotteryFilter extends DbObjectBase<Filter> {

    constructor(id: string, colllection: ICollectionReference) {
       super(id,colllection)
  
    }
 
}

export class DbLotteryFilterGroup extends DbObjectBase<FilterGroup> {

    constructor(id: string, colllection: ICollectionReference) {
       super(id,colllection)
  
    }
 
}


export class DbLotteryFilterParam extends DbObjectBase<any> {

    constructor(id: string, colllection: ICollectionReference) {
       super(id,colllection)
    }
}